import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import IncomingAchs from "./IncomingAchs"
import {IncomingAchColumns} from "./IncomingAch.types"

export default function IncomingAchsPage(): ReactElement {
	return (
		<>
			<TitleBar title="Incoming ACH" />

			<MainSectionTable>
				<IncomingAchs
					fullHeight={true}
					enableOrgFilter={true}
					enableStatusFilter={true}
					enableReviewReasonFilter={true}
					enableAmountFilter={true}
					enableDateFilter={true}
					includedColumns={[
						IncomingAchColumns.id,
						IncomingAchColumns.account,
						IncomingAchColumns.customer,
						IncomingAchColumns.bank,
						IncomingAchColumns.org,
						IncomingAchColumns.amount,
						IncomingAchColumns.status,
						IncomingAchColumns.createdAt,
					]}
				/>
			</MainSectionTable>
		</>
	)
}
